import React, { Component } from 'react'
import {path,FILE_URL} from './Constant';
export default class Services extends Component {
    constructor (props){
        super(props);
        this.state={
            data:props.data
        }
    }
    render() {
        return (
            <div id="services">
            <div className="row">
                <div className="col-md-12">
                    <h2>{this.props.static_text.services_text}</h2>
                    <div className="row my-3" id="concierge">
                        <div className="col-md-9">
                            <h6>{this.props.static_text.services_text}</h6>
                            <p>{this.props.data.concierge_text}</p>
                        </div>
                        <div className="col-md-3">
                            <img src={this.props.data.concierge_image !=null && this.props.data.concierge_image !=''?FILE_URL+'/villas/'+this.props.data.concierge_image:path+"images/img5.jpg"} className="img-fluid d-block" alt="Concierge" />
                        </div>
                    </div>
                    <div className="row" id="transport">
                        <div className="col-md-9">
                            <h6>{this.props.static_text.transport_text}</h6>
                            <p>{this.props.data.transport_text}</p>
                            
                        </div>
                        <div className="col-md-3">
                            <img src={this.props.data.transport_image !=null && this.props.data.transport_image !=''?FILE_URL+'/villas/'+this.props.data.transport_image:path+"images/img6.jpg"} className="img-fluid d-block" alt="Transport" />
                        </div>
                    </div>
                    <div className="row my-3" id="cleaning">
                        <div className="col-md-9">
                            <h6>{this.props.static_text.cleaning_text}</h6>
                            <p>{this.props.data.cleaning_text}</p>
                        </div>
                        <div className="col-md-3">
                            <img src={this.props.data.cleaning_image !=null && this.props.data.cleaning_image !=''?FILE_URL+'/villas/'+this.props.data.cleaning_image:path+"images/img7.jpg"} className="img-fluid d-block" alt="Cleaning" />
                        </div>
                    </div>
                    <div className="row" id="maintenance">
                        <div className="col-md-9">
                            <h6>{this.props.static_text.maintenance_text}</h6>
                            <p>{this.props.data.maintenance_text}</p>
                        </div>
                        <div className="col-md-3">
                            <img src={this.props.data.maintenance_image !=null && this.props.data.maintenance_image !=''?FILE_URL+'/villas/'+this.props.data.maintenance_image:path+"images/img8.jpg"} className="img-fluid d-block" alt="Maintenance" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        )
    }
}
